<div id="pop-up-container" [ngClass]="{ show: open }">
  <ng-content></ng-content>
</div>
